export const SET_TABLE_ROW_COUNT = 'SET_TABLE_ROW_COUNT';
export const REFRESH_ALERTS = 'REFRESH_ALERTS';
export const SET_FILTERS = 'SET_FILTERS';
export const SET_REPORT_TABLE_COLUMNS = 'SET_REPORT_TABLE_COLUMNS';
